import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../components/sidebar';
import { Card, Typography, Button, Row, Col, Input, Upload, Modal, Collapse } from 'antd';
import { UserOutlined, ArrowLeftOutlined, PlusOutlined, EditOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import debounce from 'lodash.debounce';
import './CampanaAudiencia.css';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const verificarusuario = "https://api.mrcirp.com/public/campanas-audiencia/existe";

const CampanaAudiencia = () => {
  const navigate = useNavigate();
  
  // Estados para información básica de la campaña
  const [campanaData, setCampanaData] = useState({
    nombrecampana: '',
    nombre: '',
    descripcion: ''
  });

  const [mensajeVerificacion, setMensajeVerificacion] = useState('');
  const [colorVerificacion, setColorVerificacion] = useState('');
  const [openBasico, setOpenBasico] = useState(true);
  
  // Estados para el contenido de la landing
  const [landingData, setLandingData] = useState({
    // Banner Principal
    banner: {
      titulo: 'Tu Título Principal Aquí',
      subtitulo: 'Subtítulo descriptivo que capture la atención',
      videoUrl: '',
      imagenUrl: ''
    },
    // Sección de Servicios
    servicios: {
      titulo: 'Nuestros Servicios',
      descripcion: 'Descripción general de los servicios que ofreces',
      items: [
        { titulo: 'Servicio 1', descripcion: 'Descripción del primer servicio' },
        { titulo: 'Servicio 2', descripcion: 'Descripción del segundo servicio' },
        { titulo: 'Servicio 3', descripcion: 'Descripción del tercer servicio' }
      ]
    },
    // Sección de Dos Columnas (imagen izquierda)
    dosColumnas: {
      imagen: '',
      titulo: 'Título de la Sección',
      descripcion: 'Descripción detallada de esta sección'
    },
    // Sección de Dos Columnas (imagen derecha)
    dosColumnasDerecha: {
      imagen: '',
      titulo: 'Título de la Segunda Sección',
      descripcion: 'Descripción detallada de esta segunda sección'
    }
  });

  const [editingSection, setEditingSection] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);

  const verificarNombre = useCallback(debounce(async (nombre) => {
    try {
      console.log(`${verificarusuario}/${nombre}`);
      const response = await axios.get(`${verificarusuario}/${nombre}`);
      if (response.data === true) {
        setMensajeVerificacion('Enlace existente');
        setColorVerificacion('red');
      } else {
        setMensajeVerificacion('Enlace disponible');
        setColorVerificacion('green');
      }
    } catch (err) {
      console.error(err);
    }
  }, 500), []);

  const handleChangeCampana = (e) => {
    const { name, value } = e.target;
    setCampanaData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'nombre') {
      verificarNombre(value);
    }
  };

  const handleCrearCampana = async () => {
    try {
      // Obtener datos del usuario logueado
      const loginUserJSON = window.localStorage.getItem('loginUser');
      let adminId = null;
      let adminNombre = '';

      if (loginUserJSON) {
        const user = JSON.parse(loginUserJSON);
        adminId = user.id;
        adminNombre = user.nombreuser || user.nombre || 'Usuario';
      }

      // Preparar datos para enviar
      const datosCompletos = {
        ...campanaData,
        ...landingData,
        adminId: adminId,
        adminNombre: adminNombre,
        // Mapear los datos del landing a los campos esperados por el API
        banner_titulo: landingData.banner.titulo,
        banner_subtitulo: landingData.banner.subtitulo,
        banner_video_url: landingData.banner.videoUrl,
        banner_imagen_url: landingData.banner.imagenUrl,
        servicios_titulo: landingData.servicios.titulo,
        servicios_descripcion: landingData.servicios.descripcion,
        servicios_items: landingData.servicios.items,
        dos_columnas_titulo: landingData.dosColumnas.titulo,
        dos_columnas_descripcion: landingData.dosColumnas.descripcion,
        dos_columnas_imagen: landingData.dosColumnas.imagen,
        dos_columnas_derecha_titulo: landingData.dosColumnasDerecha.titulo,
        dos_columnas_derecha_descripcion: landingData.dosColumnasDerecha.descripcion,
        dos_columnas_derecha_imagen: landingData.dosColumnasDerecha.imagen
      };

      console.log('Enviando datos:', datosCompletos);

      const response = await axios.post('https://api.mrcirp.com/public/campanas-audiencia', datosCompletos);
      
      if (response.data.success) {
        alert('¡Campaña de audiencia creada exitosamente!');
        // Limpiar el formulario
        setCampanaData({
          nombrecampana: '',
          nombre: '',
          descripcion: ''
        });
        setLandingData({
          banner: {
            titulo: 'Tu Título Principal Aquí',
            subtitulo: 'Subtítulo descriptivo que capture la atención',
            videoUrl: '',
            imagenUrl: ''
          },
          servicios: {
            titulo: 'Nuestros Servicios',
            descripcion: 'Descripción general de los servicios que ofreces',
            items: [
              { titulo: 'Servicio 1', descripcion: 'Descripción del primer servicio' },
              { titulo: 'Servicio 2', descripcion: 'Descripción del segundo servicio' },
              { titulo: 'Servicio 3', descripcion: 'Descripción del tercer servicio' }
            ]
          },
          dosColumnas: {
            imagen: '',
            titulo: 'Título de la Sección',
            descripcion: 'Descripción detallada de esta sección'
          },
          dosColumnasDerecha: {
            imagen: '',
            titulo: 'Título de la Segunda Sección',
            descripcion: 'Descripción detallada de esta segunda sección'
          }
        });
      } else {
        alert('Error al crear la campaña: ' + (response.data.message || 'Error desconocido'));
      }
    } catch (error) {
      console.error('Error al crear campaña:', error);
      alert('Error al crear la campaña: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleVolver = () => {
    navigate('/seleccion-tipo-campana');
  };

  const handleEdit = (section) => {
    setEditingSection(section);
  };

  const handleSave = (section, data) => {
    setLandingData(prev => ({
      ...prev,
      [section]: data
    }));
    setEditingSection(null);
  };

  const handleCancel = () => {
    setEditingSection(null);
  };

  const renderBannerSection = () => (
    <Card className="landing-section" title="🎬 Banner Principal">
      <div className="banner-preview">
        <div className="banner-content">
          <h1>{landingData.banner.titulo}</h1>
          <p>{landingData.banner.subtitulo}</p>
          {landingData.banner.videoUrl && (
            <div className="video-container">
              <iframe 
                src={landingData.banner.videoUrl} 
                title="Video Banner"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          )}
          {landingData.banner.imagenUrl && (
            <img src={landingData.banner.imagenUrl} alt="Banner" className="banner-image" />
          )}
        </div>
      </div>
      <Button 
        type="primary" 
        icon={<EditOutlined />} 
        onClick={() => handleEdit('banner')}
        className="edit-btn"
      >
        Editar Banner
      </Button>
    </Card>
  );

  const renderServiciosSection = () => (
    <Card className="landing-section" title="🛠️ Sección de Servicios">
      <div className="servicios-preview">
        <h2>{landingData.servicios.titulo}</h2>
        <p>{landingData.servicios.descripcion}</p>
        <Row gutter={[16, 16]}>
          {landingData.servicios.items.map((item, index) => (
            <Col xs={24} md={8} key={index}>
              <Card className="service-card">
                <h3>{item.titulo}</h3>
                <p>{item.descripcion}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <Button 
        type="primary" 
        icon={<EditOutlined />} 
        onClick={() => handleEdit('servicios')}
        className="edit-btn"
      >
        Editar Servicios
      </Button>
    </Card>
  );

  const renderDosColumnasSection = () => (
    <Card className="landing-section" title="📄 Sección de Dos Columnas (Imagen Izquierda)">
      <div className="dos-columnas-preview">
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            {landingData.dosColumnas.imagen ? (
              <img src={landingData.dosColumnas.imagen} alt="Sección" className="section-image" />
            ) : (
              <div className="placeholder-image">
                <UploadOutlined style={{ fontSize: '48px', color: '#ccc' }} />
                <p>Imagen de la sección</p>
              </div>
            )}
          </Col>
          <Col xs={24} md={12}>
            <h2>{landingData.dosColumnas.titulo}</h2>
            <p>{landingData.dosColumnas.descripcion}</p>
          </Col>
        </Row>
      </div>
      <Button 
        type="primary" 
        icon={<EditOutlined />} 
        onClick={() => handleEdit('dosColumnas')}
        className="edit-btn"
      >
        Editar Sección
      </Button>
    </Card>
  );

  const renderDosColumnasDerechaSection = () => (
    <Card className="landing-section" title="📄 Sección de Dos Columnas (Imagen Derecha)">
      <div className="dos-columnas-preview">
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <h2>{landingData.dosColumnasDerecha.titulo}</h2>
            <p>{landingData.dosColumnasDerecha.descripcion}</p>
          </Col>
          <Col xs={24} md={12}>
            {landingData.dosColumnasDerecha.imagen ? (
              <img src={landingData.dosColumnasDerecha.imagen} alt="Sección" className="section-image" />
            ) : (
              <div className="placeholder-image">
                <UploadOutlined style={{ fontSize: '48px', color: '#ccc' }} />
                <p>Imagen de la sección</p>
              </div>
            )}
          </Col>
        </Row>
      </div>
      <Button 
        type="primary" 
        icon={<EditOutlined />} 
        onClick={() => handleEdit('dosColumnasDerecha')}
        className="edit-btn"
      >
        Editar Sección
      </Button>
    </Card>
  );

  const renderEditModal = () => {
    if (!editingSection) return null;

    return (
      <Modal
        title={`Editar ${editingSection}`}
        open={true}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {editingSection === 'banner' && (
          <BannerEditor 
            data={landingData.banner} 
            onSave={(data) => handleSave('banner', data)}
            onCancel={handleCancel}
          />
        )}
        {editingSection === 'servicios' && (
          <ServiciosEditor 
            data={landingData.servicios} 
            onSave={(data) => handleSave('servicios', data)}
            onCancel={handleCancel}
          />
        )}
        {editingSection === 'dosColumnas' && (
          <DosColumnasEditor 
            data={landingData.dosColumnas} 
            onSave={(data) => handleSave('dosColumnas', data)}
            onCancel={handleCancel}
          />
        )}
        {editingSection === 'dosColumnasDerecha' && (
          <DosColumnasEditor 
            data={landingData.dosColumnasDerecha} 
            onSave={(data) => handleSave('dosColumnasDerecha', data)}
            onCancel={handleCancel}
          />
        )}
      </Modal>
    );
  };

  return (
    <div>
      <Sidebar>
        <div className="campana-audiencia-container">
          <div className="page-header">
            <Title level={2} className="page-title">
              👥 Maquetador de Campana de Audiencia
            </Title>
            <Text className="page-subtitle">
              Crea tu landing page personalizada con nuestro editor visual
            </Text>
            <div className="header-actions">
              <Button 
                type="default" 
                icon={<ArrowLeftOutlined />} 
                onClick={handleVolver}
              >
                Volver
              </Button>
              <Button 
                type="primary" 
                onClick={() => setPreviewMode(!previewMode)}
              >
                {previewMode ? 'Editar' : 'Vista Previa'}
              </Button>
            </div>
          </div>

          {!previewMode ? (
            <div className="editor-mode">
              {/* Información Básica de la Campaña */}
              <Card className="landing-section" title="📋 Información Básica de la Campaña">
                <Collapse 
                  activeKey={openBasico ? ['1'] : []} 
                  onChange={(key) => setOpenBasico(key.includes('1'))}
                >
                  <Panel header="📋 Información Básica" key="1">
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={12}>
                        <div className="form-group">
                          <label><strong>Nombre de la campaña</strong></label>
                          <Input
                            className="mb-2"
                            type="text"
                            name="nombrecampana"
                            value={campanaData.nombrecampana}
                            onChange={handleChangeCampana}
                            placeholder="Ej: Mi Campaña 2024"
                          />
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div className="form-group">
                          <label><strong>Enlace de la campaña</strong></label>
                          <Input
                            className="mb-2"
                            type="text"
                            name="nombre"
                            value={campanaData.nombre}
                            onChange={handleChangeCampana}
                            placeholder="minombre (sin espacios)"
                          />
                          <Text type="secondary" style={{ fontSize: '12px' }}>
                            www.mrcirp.com/minombre
                          </Text>
                          <br />
                          <Text style={{ color: colorVerificacion, fontSize: '12px' }}>
                            {mensajeVerificacion}
                          </Text>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24}>
                        <div className="form-group">
                          <label><strong>Descripción de la campaña</strong></label>
                          <TextArea
                            name="descripcion"
                            value={campanaData.descripcion}
                            onChange={handleChangeCampana}
                            maxLength={150}
                            rows={3}
                            placeholder="Describe tu campaña (máximo 150 caracteres)"
                          />
                          <Text type="secondary" style={{ fontSize: '12px' }}>
                            {campanaData.descripcion.length}/150 caracteres
                          </Text>
                        </div>
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>
              </Card>

              {renderBannerSection()}
              {renderServiciosSection()}
              {renderDosColumnasSection()}
              {renderDosColumnasDerechaSection()}
              
              {/* Botón para crear la campaña */}
              <Card className="landing-section">
                <div className="text-center">
                  <Button 
                    type="primary" 
                    size="large"
                    onClick={handleCrearCampana}
                    style={{ 
                      background: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '12px 32px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      height: 'auto'
                    }}
                  >
                    🚀 Crear Campaña de Audiencia
                  </Button>
                  <div style={{ marginTop: '12px' }}>
                    <Text type="secondary">
                      Al crear la campaña, se guardará toda la información del landing page
                    </Text>
                  </div>
                </div>
              </Card>
            </div>
          ) : (
            <div className="preview-mode">
              <div className="landing-preview">
                <div className="banner-section">
                  <h1>{landingData.banner.titulo}</h1>
                  <p>{landingData.banner.subtitulo}</p>
                  {landingData.banner.videoUrl && (
                    <div className="video-container">
                      <iframe 
                        src={landingData.banner.videoUrl} 
                        title="Video Banner"
                        frameBorder="0"
                        allowFullScreen
                      />
                    </div>
                  )}
                </div>
                
                <div className="servicios-section">
                  <h2>{landingData.servicios.titulo}</h2>
                  <p>{landingData.servicios.descripcion}</p>
                  <Row gutter={[16, 16]}>
                    {landingData.servicios.items.map((item, index) => (
                      <Col xs={24} md={8} key={index}>
                        <Card className="service-card">
                          <h3>{item.titulo}</h3>
                          <p>{item.descripcion}</p>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>

                <div className="dos-columnas-section">
                  <Row gutter={[24, 24]}>
                    <Col xs={24} md={12}>
                      {landingData.dosColumnas.imagen ? (
                        <img src={landingData.dosColumnas.imagen} alt="Sección" className="section-image" />
                      ) : (
                        <div className="placeholder-image">
                          <UploadOutlined style={{ fontSize: '48px', color: '#ccc' }} />
                        </div>
                      )}
                    </Col>
                    <Col xs={24} md={12}>
                      <h2>{landingData.dosColumnas.titulo}</h2>
                      <p>{landingData.dosColumnas.descripcion}</p>
                    </Col>
                  </Row>
                </div>

                <div className="dos-columnas-section-derecha">
                  <Row gutter={[24, 24]}>
                    <Col xs={24} md={12}>
                      <h2>{landingData.dosColumnasDerecha.titulo}</h2>
                      <p>{landingData.dosColumnasDerecha.descripcion}</p>
                    </Col>
                    <Col xs={24} md={12}>
                      {landingData.dosColumnasDerecha.imagen ? (
                        <img src={landingData.dosColumnasDerecha.imagen} alt="Sección" className="section-image" />
                      ) : (
                        <div className="placeholder-image">
                          <UploadOutlined style={{ fontSize: '48px', color: '#ccc' }} />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          )}

          {renderEditModal()}
        </div>
      </Sidebar>
    </div>
  );
};

// Componentes de edición
const BannerEditor = ({ data, onSave, onCancel }) => {
  const [formData, setFormData] = useState(data);

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <div className="editor-form">
      <div className="form-group">
        <label>Título Principal</label>
        <Input 
          value={formData.titulo} 
          onChange={(e) => setFormData({...formData, titulo: e.target.value})}
          placeholder="Ingresa el título principal"
        />
      </div>
      <div className="form-group">
        <label>Subtítulo</label>
        <TextArea 
          value={formData.subtitulo} 
          onChange={(e) => setFormData({...formData, subtitulo: e.target.value})}
          placeholder="Ingresa el subtítulo"
          rows={3}
        />
      </div>
      <div className="form-group">
        <label>URL del Video (YouTube/Vimeo)</label>
        <Input 
          value={formData.videoUrl} 
          onChange={(e) => setFormData({...formData, videoUrl: e.target.value})}
          placeholder="https://youtube.com/watch?v=..."
        />
      </div>
      <div className="form-group">
        <label>URL de Imagen</label>
        <Input 
          value={formData.imagenUrl} 
          onChange={(e) => setFormData({...formData, imagenUrl: e.target.value})}
          placeholder="https://ejemplo.com/imagen.jpg"
        />
      </div>
      <div className="form-actions">
        <Button onClick={onCancel}>Cancelar</Button>
        <Button type="primary" onClick={handleSubmit}>Guardar</Button>
      </div>
    </div>
  );
};

const ServiciosEditor = ({ data, onSave, onCancel }) => {
  const [formData, setFormData] = useState(data);

  const handleSubmit = () => {
    onSave(formData);
  };

  const updateService = (index, field, value) => {
    const newItems = [...formData.items];
    newItems[index] = { ...newItems[index], [field]: value };
    setFormData({ ...formData, items: newItems });
  };

  return (
    <div className="editor-form">
      <div className="form-group">
        <label>Título de la Sección</label>
        <Input 
          value={formData.titulo} 
          onChange={(e) => setFormData({...formData, titulo: e.target.value})}
          placeholder="Título de los servicios"
        />
      </div>
      <div className="form-group">
        <label>Descripción General</label>
        <TextArea 
          value={formData.descripcion} 
          onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
          placeholder="Descripción de los servicios"
          rows={3}
        />
      </div>
      {formData.items.map((item, index) => (
        <div key={index} className="service-editor">
          <h4>Servicio {index + 1}</h4>
          <div className="form-group">
            <label>Título</label>
            <Input 
              value={item.titulo} 
              onChange={(e) => updateService(index, 'titulo', e.target.value)}
              placeholder="Título del servicio"
            />
          </div>
          <div className="form-group">
            <label>Descripción</label>
            <TextArea 
              value={item.descripcion} 
              onChange={(e) => updateService(index, 'descripcion', e.target.value)}
              placeholder="Descripción del servicio"
              rows={2}
            />
          </div>
        </div>
      ))}
      <div className="form-actions">
        <Button onClick={onCancel}>Cancelar</Button>
        <Button type="primary" onClick={handleSubmit}>Guardar</Button>
      </div>
    </div>
  );
};

const DosColumnasEditor = ({ data, onSave, onCancel }) => {
  const [formData, setFormData] = useState(data);

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <div className="editor-form">
      <div className="form-group">
        <label>Título de la Sección</label>
        <Input 
          value={formData.titulo} 
          onChange={(e) => setFormData({...formData, titulo: e.target.value})}
          placeholder="Título de la sección"
        />
      </div>
      <div className="form-group">
        <label>Descripción</label>
        <TextArea 
          value={formData.descripcion} 
          onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
          placeholder="Descripción de la sección"
          rows={4}
        />
      </div>
      <div className="form-group">
        <label>URL de la Imagen</label>
        <Input 
          value={formData.imagen} 
          onChange={(e) => setFormData({...formData, imagen: e.target.value})}
          placeholder="https://ejemplo.com/imagen.jpg"
        />
      </div>
      <div className="form-actions">
        <Button onClick={onCancel}>Cancelar</Button>
        <Button type="primary" onClick={handleSubmit}>Guardar</Button>
      </div>
    </div>
  );
};

export default CampanaAudiencia;
